var map = {
	"./Green-VeryLow.png": 967,
	"./Green-VeryLow.svg": 2409,
	"./Red-Excessive.png": 963,
	"./Red-Excessive.svg": 2410,
	"./RedYellow-Significant.png": 964,
	"./RedYellow-Significant.svg": 2411,
	"./White-Unknown.png": 584,
	"./White-Unknown.svg": 2412,
	"./Yellow-Moderate.png": 965,
	"./Yellow-Moderate.svg": 2413,
	"./YellowGreen-Low.png": 966,
	"./YellowGreen-Low.svg": 2414
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2408;


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map ^\.\/.*$
// module id = 2408
// module chunks = 1